module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blockHeader__wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "blockHeader"
  }, [_vm._v(_vm._s(_vm.val))]), _vm._v(" "), _c('span', {
    staticClass: "blockHeader__back"
  }, [_vm._v(_vm._s(_vm.val))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d49a1b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blockHeader.vue
// module id = 69
// module chunks = 0